import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {Button, TextField, Tooltip} from '@material-ui/core';

const styles = () => ({
  textField: {
    marginTop: '10px',
    marginLeft: '10px',
    marginRight: '10px',
    width: '90%',
  },
  button: {
    margin: '10px',
  },
});

function BasicLogin(props) {
  const {
    username,
    password,
    onLogin,
    classes,
    onChangeUsername,
    onChangePassword,
  } = props;
  const handleLogin = () => {
    onLogin(username, password);
  };

  return (
    <div>
      <TextField
        className={classes.textField}
        label="Username"
        type="text"
        onChange={onChangeUsername}
        value={username}
        autoComplete="username"
        fullWidth
      />
      <TextField
        className={classes.textField}
        label="Password"
        type="password"
        onChange={onChangePassword}
        value={password}
        autoComplete="current-password"
        margin="normal"
        fullWidth
      />
      <Tooltip title="Login">
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          onClick={handleLogin}
          disabled={!password}
        >
          Login
        </Button>
      </Tooltip>
    </div>
  );
}

BasicLogin.propTypes = {
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  onChangeUsername: PropTypes.func.isRequired,
  onChangePassword: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BasicLogin);
